<template>
  <v-card class="mx-auto" outlined elevation="24" shaped rounded color="#96298A">
          <v-card-text>            
            <v-row class="fill-height" align-content="center" justify="center">
              <v-col cols="12" class="text-subtitle-1 text-center">
                Cargando por favor espere...
              </v-col>
              <v-col cols="12">
                <v-progress-linear
                  color="#FC8333"
                  indeterminate
                  rounded
                  height="10"
                ></v-progress-linear>
              </v-col>              
            </v-row>
          </v-card-text>
        </v-card>
</template>
<script>
export default {

}
</script>

<style>

</style>